// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"e82bad1d","93":"f3ceee7e","859":"7e075bbc"}[chunkId] + ".chunk.js";
};